import * as React from 'react';
import type { SVGProps } from 'react';
const PersonAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1277_19901"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1277_19901)">
      <path
        d="M15.0002 11.6667V9.16668H12.5002V7.50001H15.0002V5.00001H16.6668V7.50001H19.1668V9.16668H16.6668V11.6667H15.0002ZM7.50016 10C6.5835 10 5.79877 9.67362 5.146 9.02084C4.49322 8.36807 4.16683 7.58334 4.16683 6.66668C4.16683 5.75001 4.49322 4.96529 5.146 4.31251C5.79877 3.65973 6.5835 3.33334 7.50016 3.33334C8.41683 3.33334 9.20155 3.65973 9.85433 4.31251C10.5071 4.96529 10.8335 5.75001 10.8335 6.66668C10.8335 7.58334 10.5071 8.36807 9.85433 9.02084C9.20155 9.67362 8.41683 10 7.50016 10ZM0.833496 16.6667V14.3333C0.833496 13.8611 0.955024 13.4271 1.19808 13.0313C1.44114 12.6354 1.76405 12.3333 2.16683 12.125C3.02794 11.6945 3.90294 11.3715 4.79183 11.1563C5.68072 10.941 6.5835 10.8333 7.50016 10.8333C8.41683 10.8333 9.31961 10.941 10.2085 11.1563C11.0974 11.3715 11.9724 11.6945 12.8335 12.125C13.2363 12.3333 13.5592 12.6354 13.8022 13.0313C14.0453 13.4271 14.1668 13.8611 14.1668 14.3333V16.6667H0.833496ZM2.50016 15H12.5002V14.3333C12.5002 14.1806 12.462 14.0417 12.3856 13.9167C12.3092 13.7917 12.2085 13.6945 12.0835 13.625C11.3335 13.25 10.5766 12.9688 9.81266 12.7813C9.04877 12.5938 8.27794 12.5 7.50016 12.5C6.72239 12.5 5.95155 12.5938 5.18766 12.7813C4.42377 12.9688 3.66683 13.25 2.91683 13.625C2.79183 13.6945 2.69114 13.7917 2.61475 13.9167C2.53836 14.0417 2.50016 14.1806 2.50016 14.3333V15ZM7.50016 8.33334C7.9585 8.33334 8.35086 8.17015 8.67725 7.84376C9.00364 7.51737 9.16683 7.12501 9.16683 6.66668C9.16683 6.20834 9.00364 5.81598 8.67725 5.48959C8.35086 5.1632 7.9585 5.00001 7.50016 5.00001C7.04183 5.00001 6.64947 5.1632 6.32308 5.48959C5.99669 5.81598 5.8335 6.20834 5.8335 6.66668C5.8335 7.12501 5.99669 7.51737 6.32308 7.84376C6.64947 8.17015 7.04183 8.33334 7.50016 8.33334Z"
        fill="#475CB0"
      />
    </g>
  </svg>
);
export default PersonAdd;
